// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"274":"8fa56f98","453":"319cae8f","549":"1c46961f","781":"637fdbea"}[chunkId] + ".chunk.js";
};